module.exports = __webpack_public_path__ + "img/hk_room_floorplan_11.f1349934.png";